import { useContext, useEffect } from 'react';

import { GlobalContext } from '../../../GlobalContext';
import Checkbox from "../../../components/Checkbox/Checkbox";
import { IconAiStars, IconAiSearchArrow } from '../../../icons';

interface iGlobalSearchNewHeaderProps {
	setValue: (value: string) => void;
	setNewSearchValue: (value: string) => void;
	searchValue: string;
}

const GlobalSearchNewHeader = ({
	setValue,
	setNewSearchValue,
	searchValue,
}: iGlobalSearchNewHeaderProps) => {

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Enter') {
				setValue(searchValue);
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [searchValue, setValue]);

	const {
		inMyLibrary,
		setInMyLibrary,
	} = useContext(GlobalContext);

	return (
		<div className="GlobalSearch__header">
			<div className="GlobalSearch__header-text">
				<IconAiStars />
				<strong>
					Ask a question &nbsp;
				</strong>
				or just type in any food, flavor, or beverage to get started.
			</div>
			<input
				className="GlobalSearch__input"
				autoFocus
				value={searchValue}
				onChange={(event) => setNewSearchValue(event.target.value)}
			/>
			{searchValue.trim().length > 0 && (
				<IconAiSearchArrow className="GlobalSearch__input-arrow" onClick={() => setValue(searchValue)} />
			)}
			<div className="GlobalSearch__toggle">
				<Checkbox
					color="white"
					isChecked={inMyLibrary}
					label="In my library"
					onChange={() => setInMyLibrary(!inMyLibrary)}
					isToggle
				/>
			</div>
		</div>
	);
}

export default GlobalSearchNewHeader;	